import { render, staticRenderFns } from "./CardTotalSO.vue?vue&type=template&id=c4e230a0"
import script from "./CardTotalSO.vue?vue&type=script&lang=js"
export * from "./CardTotalSO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports